import React, { useEffect, useState } from 'react'
import { Query } from 'react-apollo';
import { useIntl } from 'react-intl';
import patternsQuery from 'scenes/ProductsPage/components/ProductsList/query';
import { PLACEHOLDER_MESSAGES_STEP1 } from '../../constants';
import { useFormikContext } from 'formik';
import MultiSelect from './components/MultiSelect';

const ProductsSelect = ({ name, updateField }) => {
  const intl = useIntl();
  const { values: { products } } = useFormikContext();

  return (
    <Query query={patternsQuery}>
      {({ loading, data, error, refetch }) => {
        const patternsList = data?.patterns?.edges?.map(({ node }) => ({
          id: node.id,
          value: node.id,
          label: `${node.code} - ${node.nameWithSuperscriptR}`,
        })) || [];

        const handleRefetch = (referenceName) => {
          refetch({
            search: referenceName,
          })
        }

        if (error) {
          const {graphQLErrors, networkError} = error;
          if (graphQLErrors || networkError) {
            console.error("Error fetching products GraphQL:", graphQLErrors);
            console.error("Error fetching products Network:", networkError);
          }
        }

        return (
          <MultiSelect
            config={{
              name,
              initialValues: products,
              selectValues: patternsList,
              disabled: loading,
              placeholderMessage: intl.formatMessage(
                PLACEHOLDER_MESSAGES_STEP1["products"]
              ),
              disabledPlaceholder: intl.formatMessage(
                { id: "ProjectStepForm.loading.products", defaultMessage: "Cargando productos..." }
              ),
            }}
            updateField={updateField}
            onFilterChange={handleRefetch}
          />
        );
      }}
    </Query>
  )
}

export default ProductsSelect;